import { PhoneScreen } from '../features/account/PhoneScreen'

export function ProfilePhonePage() {
  return <PhoneScreen />
}
